var adHeight = 500;
var adWidth = 600;

window.addEventListener("message", function (event) {

    if (event.data == "Right1" || event.data == "Right2") {

        var adPos = event.data;
    
        $(function () {
            $("#div-gpt-ad-" + adPos + " iframe").animate({
                height: adHeight + "px",
                width: adWidth + "px"
            }, { duration: 1000, queue: false });

        });


        if (adWidth == 600) {

            $("#div-gpt-ad-" + adPos + " iframe").animate({
                marginLeft:  "-150px"
            }, { duration: 1000, queue: false });

            $("#div-gpt-ad-" + adPos).animate({
                height: adHeight + 56 + "px",
                width: adWidth + 56 + "px",
                textAlign: "right",
                padding: "28px",
                marginLeft: -(adWidth / 2) + 10 +  "px"
                //position: "relative"
            }, { duration: 1000, queue: false });

            adHeight = 250;
            adWidth = 300;

        } else {

            $("#div-gpt-ad-" + adPos + " iframe").animate({
                marginLeft: "0px"
            }, { duration: 1000, queue: false });

            $("#div-gpt-ad-" + adPos).animate({
                height: adHeight + 56 + "px",
                width: adWidth + 66 + "px",
                textAlign: "right",
                padding: "28px",
                marginLeft: "0px"
                //position: "relative"
            }, { duration: 1000, queue: false });


            adHeight = 500;
            adWidth = 600;

        }


    }

});